<template>
    <b-alert
        :show="false"
        class="update-notification"
        fade
        @dismiss-count-down="countDownChanged"
    >
        <div class="alert-body bg-warning text-white">
            <feather-icon
                icon="InfoIcon"
            ></feather-icon>
            New content is available. ({{ dismissCountDown }}s)
            <b-button
                size="sm"
                variant="success"
                @click="refreshPage"
            >
                Refresh
            </b-button>
        </div>
    </b-alert>
</template>

<script>
import { ref } from '@vue/composition-api'
export default {
    setup () {
        const dismissCountDown = ref(0)
        const newContentAvailable = ref(false)
        const registration = ref(null)
        const updateAvailable = (event) => {
            newContentAvailable.value = true
            registration.value = event.detail
            dismissCountDown.value = 100
        }

        const refreshPage = () => {
            if (registration?.value.waiting) registration.value.waiting.postMessage({ type: 'SKIP_WAITING' })
            if (registration.value) {
                newContentAvailable.value = false
                window.location.reload()
            }
        }
        const countDownChanged = (countDown) => {
            dismissCountDown.value = countDown
        }
        document.addEventListener('swUpdated', updateAvailable, { once: true })
        return {
            dismissCountDown,
            countDownChanged,
            newContentAvailable,
            registration,
            refreshPage
        }
    }
}
</script>

<style>
.update-notification {
    position: fixed !important;
    bottom: 1rem;
    right: 2rem;
    z-index: 1001
}
</style>
